// extracted by mini-css-extract-plugin
module.exports = {"content":"WidgetNetSalesByProvider_content__W2s4Y"};